function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.14 15.57L7.7 12.28l1.54-1.47 1.9 1.82 3.61-3.46 1.54 1.47-5.15 4.93zM22.33 3.75C18.05 3.75 14.77 2.58 12 0 9.23 2.58 5.95 3.75 1.67 3.75 1.67 10.47.22 20.09 12 24c11.78-3.91 10.33-13.53 10.33-20.25z",
  fillRule: "evenodd",
  clipRule: "evenodd"
});

function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "cfcde929479831287548c9f63d55c953.svg";
export { SvgShield as ReactComponent };